// extracted by mini-css-extract-plugin
export default {"attribute":"NftAttributes_attribute__fbC2+","traitValue":"NftAttributes_traitValue__jmu6V"};